@if( canResendAdditionalOwnerRequirement() ) {
  <div class="tw-w-full contact-action">
    <button
      matTooltip="Sends to all additional owners who have not completed the pre-approval requirements request."
      matTooltipPosition="above"
      (click)="resendAdditionalOwnerRequirementRequest()"
      data-cy="resend-additional-owner-requirement"
      class="resend-additional-owner-requirement-button tw-w-full tw-flex tw-flex-row tw-h-32"
      mat-button
      color="primary">
      <span class="tw-flex-grow tw-text-left tw-text-black">Send pre-approval link to additional owners</span>
      <span class="send-icon-container tw-inline-block tw-flex-none tw-rounded-lg tw-border tw-px-2 tw-size[32]">
        <mat-icon class="send-icon tw-place-items-center tw-mt-1">send</mat-icon>
      </span>
    </button>
  </div>
}
